const formatters = new Map<number, Intl.NumberFormat>();

const formatterFor = (maximumFractionDigits: number): Intl.NumberFormat => {
    let formatter = formatters.get(maximumFractionDigits);
    if (!formatter) {
        formatter = new Intl.NumberFormat('en-US', { useGrouping: true, maximumFractionDigits });
        formatters.set(maximumFractionDigits, formatter);
    }
    return formatter;
};

export const formatNumber = (value: string | number | null | undefined, decimals?: number): string => {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(value);
    if (Number.isNaN(n)) return String(value);
    return formatterFor(Math.min(Math.max(decimals ?? 20, 0), 20)).format(n);
};
